import React from 'react'
import Keydates from './Keydates/Keydates'
import RegistrationFees from './RegistrationFees/RegistrationFees'

const FessandDates = () => {
    return (
        <div style={{ padding: '1rem' }}>
            <Keydates />
            <RegistrationFees />
        </div>
    )
}

export default FessandDates